import React from 'react';
import { Box, CircularProgress, Typography, styled } from '@mui/material';
import { useAppLinkParams } from 'features/appLinks/useAppLinkParams';
import { useEnrollment } from 'features/enrollment/hooks/useEnrollment';
import { NotFound } from './NotFound';

const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  width: '100vw',
  gap: 16,
});

export const Enrollment = () => {
  const { params } = useAppLinkParams({
    requiresAuth: true,
    requiredParams: ['enrollmentId'],
  });

  const { isProcessing, error } = useEnrollment(params.enrollmentId);

  if (error) {
    return <NotFound />;
  }

  return (
    <Container as="main" role="status" aria-live="polite">
      <CircularProgress
        aria-label={isProcessing ? 'Processing enrollment' : 'Completing enrollment'}
      />
      {isProcessing && (
        <Typography color="text.secondary" textAlign="center">
          Processing enrollment...
        </Typography>
      )}
    </Container>
  );
};
